import mutations from './mutations'
import actions from './actions'
//Login模块mixins
import { loginMutations, loginActions, loginState } from "@/pages/Login/store/index.js"

// let $bus = new Vue({});

const state = {
  efchat: {
    $bus: new Vue({})
  },
  newResume: false,
  editActive: null,
  assistantStatus: false,
  assistantnum: 0,
  subConditionData: null,
  chatDatalist: null,
  MreturnData: false,
  axios_responseData: null,
  MesmodelMes: null,
  loadingShow: true,
  HomebtnData: null,
  HomebtnHrData: null,
  whichHeader: false,
  MessageNum: 0,
  configData: null,
  versionConfigData: null,
  searchPositionHistory: [],
  homePageHeadData: null,
  descriptionData: null,
  developmentData: null,
  leadTeamData: null,
  welfareOthersData: null,
  // enterpriseDetailsData:null,
  locationData: null,
  environmentPhotoPathData: null,
  certificationData: null,
  perfectFlag: null,
  lock: {
    flag: null,
    callback: null
  },
  certificationStatusData: null
}
console.log("state", Object.assign(state, loginState))
export default new Vuex.Store({
  state: Object.assign(state, loginState),
  actions: Object.assign(actions, loginActions),
  mutations: Object.assign(mutations, loginMutations)
})
